<template>
  <iframe
      :src="`https://player.twitch.tv/?channel=`+channel+`&parent=`+location.hostname"
      :height="height"
      :width="width"
      frameBorder="0" scrolling="no" style="border:0"
      allowfullscreen="true">
  </iframe>

</template>

<script>
export default {
  name: "TwitchLive",
  props:['width','height','channel']
}
</script>

<style scoped>
iframe {
  padding: 0;
  margin: 0;
}
</style>